export class Sucursal {
    id: number;
    nombre: string;
    descripcion: string;
}